 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/TitlePage'
 import X9781541541771 from '@/components/x9781541541771'
 import X97815415417711 from '@/components/x9781541541771-1'
 import X97815415417712 from '@/components/x9781541541771-2'
 import X97815415417713 from '@/components/x9781541541771-3'
 import X97815415417714 from '@/components/x9781541541771-4'
 import X97815415417715 from '@/components/x9781541541771-5'
 import X97815415417716 from '@/components/x9781541541771-6'
 import X97815415417717 from '@/components/x9781541541771-7'
 import X97815415417718 from '@/components/x9781541541771-8'
 import X97815415417719 from '@/components/x9781541541771-9'
 import X978154154177110 from '@/components/x9781541541771-10'
 import X978154154177111 from '@/components/x9781541541771-11'
 import X978154154177112 from '@/components/x9781541541771-12'
 import X978154154177113 from '@/components/x9781541541771-13'
 import X978154154177114 from '@/components/x9781541541771-14'
 import X978154154177115 from '@/components/x9781541541771-15'
 import X978154154177116 from '@/components/x9781541541771-16'
 import X978154154177117 from '@/components/x9781541541771-17'
 import X978154154177118 from '@/components/x9781541541771-18'
 import X978154154177119 from '@/components/x9781541541771-19'
 import X978154154177120 from '@/components/x9781541541771-20'
 import X978154154177121 from '@/components/x9781541541771-21'
 import X978154154177122 from '@/components/x9781541541771-22'
 import X978154154177123 from '@/components/x9781541541771-23'
 import X978154154177124 from '@/components/x9781541541771-24'
 import X978154154177125 from '@/components/x9781541541771-25'
 import X978154154177126 from '@/components/x9781541541771-26'
 import X978154154177127 from '@/components/x9781541541771-27'
 import X978154154177128 from '@/components/x9781541541771-28'
 import X978154154177129 from '@/components/x9781541541771-29'
 import X978154154177130 from '@/components/x9781541541771-30'
 import X978154154177131 from '@/components/x9781541541771-31'
 import X978154154177132 from '@/components/x9781541541771-32'
 import X978154154177133 from '@/components/x9781541541771-33'
 import X978154154177134 from '@/components/x9781541541771-34'
 import X978154154177135 from '@/components/x9781541541771-35'
 import X978154154177136 from '@/components/x9781541541771-36'
 import X978154154177137 from '@/components/x9781541541771-37'
 import X978154154177138 from '@/components/x9781541541771-38'
 import X978154154177139 from '@/components/x9781541541771-39'
 import X978154154177140 from '@/components/x9781541541771-40'
 import X978154154177141 from '@/components/x9781541541771-41'
 import X978154154177142 from '@/components/x9781541541771-42'
 import X978154154177143 from '@/components/x9781541541771-43'
 import X978154154177144 from '@/components/x9781541541771-44'
 import X978154154177145 from '@/components/x9781541541771-45'
 import X978154154177146 from '@/components/x9781541541771-46'
 import X978154154177147 from '@/components/x9781541541771-47'
 import X978154154177148 from '@/components/x9781541541771-48'
 import X978154154177149 from '@/components/x9781541541771-49'
 import X978154154177150 from '@/components/x9781541541771-50'
 import X978154154177151 from '@/components/x9781541541771-51'
 import X978154154177152 from '@/components/x9781541541771-52'
 import X978154154177153 from '@/components/x9781541541771-53'
 import X978154154177154 from '@/components/x9781541541771-54'
 import X978154154177155 from '@/components/x9781541541771-55'
 import X978154154177156 from '@/components/x9781541541771-56'
 import X978154154177157 from '@/components/x9781541541771-57'
 import X978154154177158 from '@/components/x9781541541771-58'
 import X978154154177159 from '@/components/x9781541541771-59'
 import X978154154177160 from '@/components/x9781541541771-60'
 import X978154154177161 from '@/components/x9781541541771-61'
 import X978154154177162 from '@/components/x9781541541771-62'
 import X978154154177163 from '@/components/x9781541541771-63'
 import X978154154177164 from '@/components/x9781541541771-64'
 import X978154154177165 from '@/components/x9781541541771-65'
 import X978154154177166 from '@/components/x9781541541771-66'
 import X978154154177167 from '@/components/x9781541541771-67'
 import X978154154177168 from '@/components/x9781541541771-68'
 import X978154154177169 from '@/components/x9781541541771-69'
 import RASTERPAGE from '@/components/RasterPage'
 import BACKCOVER from '@/components/Backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/TitlePage",
 			"name" : "TitlePage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/x9781541541771",
 			"name" : "x9781541541771",
 			"component" : X9781541541771
 		},
 		{
 			"path" : "/x9781541541771-1",
 			"name" : "x9781541541771-1",
 			"component" : X97815415417711
 		},
 		{
 			"path" : "/x9781541541771-2",
 			"name" : "x9781541541771-2",
 			"component" : X97815415417712
 		},
 		{
 			"path" : "/x9781541541771-3",
 			"name" : "x9781541541771-3",
 			"component" : X97815415417713
 		},
 		{
 			"path" : "/x9781541541771-4",
 			"name" : "x9781541541771-4",
 			"component" : X97815415417714
 		},
 		{
 			"path" : "/x9781541541771-5",
 			"name" : "x9781541541771-5",
 			"component" : X97815415417715
 		},
 		{
 			"path" : "/x9781541541771-6",
 			"name" : "x9781541541771-6",
 			"component" : X97815415417716
 		},
 		{
 			"path" : "/x9781541541771-7",
 			"name" : "x9781541541771-7",
 			"component" : X97815415417717
 		},
 		{
 			"path" : "/x9781541541771-8",
 			"name" : "x9781541541771-8",
 			"component" : X97815415417718
 		},
 		{
 			"path" : "/x9781541541771-9",
 			"name" : "x9781541541771-9",
 			"component" : X97815415417719
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js